import { render } from "./CaseReports.vue?vue&type=template&id=46b08e9f"
import script from "./CaseReports.vue?vue&type=script&lang=js"
export * from "./CaseReports.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/reports/CaseReports.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46b08e9f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46b08e9f', __exports__)) {
    console.log('reload')
    api.reload('46b08e9f', __exports__)
  }
  
  module.hot.accept("./CaseReports.vue?vue&type=template&id=46b08e9f", () => {
    console.log('re-render')
    api.rerender('46b08e9f', render)
  })

}


export default __exports__